define('Promise',['shared/lib/RSVP'], function (RSVP) {
    var Promise = function(func){
        return new RSVP.Promise(func);
    };
    Promise.resolve = function(){
        return RSVP.resolve.apply(RSVP, arguments);
    };
    Promise.reject = function(){
        return RSVP.reject.apply(RSVP, arguments);
    };
    Promise.all = RSVP.all;
    return Promise;
});
